let common = [
  {
    path: '/common_index',
    name: '主页',
    component: () => import('@/pages/common/index')
  },
  {
    path: '/online_doc_list',
    name: '医生列表',
    component: () => import('@/pages/common/online_doc_list')
  }
]

export default common
